import { toFloat } from "./utils";

export function getDeviceMemory(): number {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return toFloat((navigator as any).deviceMemory, -1);
}
